import React from 'react';
import './TodosLoading.css'

function TodosLoading() {
  
  return (
    <div className='loading'>
        <div className="loading-icon" />
    </div>
  );
}

export { TodosLoading };